<s1-input-multiselect class="mb-2" [control]="control" [label]="label" [options]="options" (onFilterChange)="setNumeroAndSearch($event)"></s1-input-multiselect>